import {Injectable, OnDestroy} from '@angular/core';
import {SearchWidgetDataItem} from '../../types/SearchWidgetDataItem';
import {SearchWidgetContentListItem} from '../../types/SearchWidgetContentListItem';
import {SearchState} from '../../types/SearchState';
import {SearchStateFieldsEnum} from '../../enums/SearchEnums';
import {QueryParams} from '../../types/QueryParams';
import {UrlBuilderService} from '../url-builder.service';
import {RoutesEnums} from '../../enums/RoutesEnums';
import {ToolsService} from '../tools.service';
import {Subscription} from 'rxjs';
import {DefaultValuesService} from '../default-values.service';
import {SearchHelperService} from '../search-helper.service';

@Injectable({
  providedIn: 'root',
})
export class SearchWidgetUrlBuilderService implements OnDestroy {
  private baseUrl: string[] = ['/', RoutesEnums.SEARCH];
  private subscriptions: Subscription[] = [];

  constructor(
    private defaults: DefaultValuesService,
    private tools: ToolsService,
    private urlBuilder: UrlBuilderService,
    private searchHelper: SearchHelperService,
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  public getSearchResultsRouterLink(
    item: SearchWidgetDataItem | SearchWidgetContentListItem,
    stateUrlPathField: string,
    useLocationSearch: boolean = false,
    overwriteTaxonomies: boolean = false,
    searchState: SearchState,
  ): string[] {
    const potentialState: SearchState = this.getSearchResultsRouterLinkPotentialState(
      item,
      stateUrlPathField,
      useLocationSearch,
      overwriteTaxonomies,
      searchState,
    );
    return this.urlBuilder.CreateSearchResultsBaseRouterLink(potentialState, this.baseUrl);
  }

  public getSearchResultsRouterLinkPotentialState(
    item: SearchWidgetDataItem | SearchWidgetContentListItem,
    stateUrlPathField: string,
    useLocationSearch: boolean,
    overwriteTaxonomies: boolean,
    searchState: SearchState,
  ): SearchState {
    let potentialState: SearchState = this.tools.clone(searchState);

    if (overwriteTaxonomies) {
      potentialState[SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE] =
        potentialState[SearchStateFieldsEnum.CARE_SERVICE_TYPE] =
        potentialState[SearchStateFieldsEnum.SYMPTOM] =
          '';
    }

    if (
      stateUrlPathField === SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE ||
      stateUrlPathField === SearchStateFieldsEnum.CARE_SERVICE_TYPE ||
      stateUrlPathField === SearchStateFieldsEnum.SYMPTOM
    ) {
      potentialState.freeSearchTerm = '';
    }

    potentialState[stateUrlPathField] = !this.tools.isNil(item) ? item.urlPath : '';
    potentialState = this.modifySearchStateWithNewPotentialValues(potentialState, useLocationSearch, false);
    potentialState.attributes = {};
    return potentialState;
  }

  public getSearchResultsQueryParams(
    item: SearchWidgetDataItem | SearchWidgetContentListItem,
    stateUrlPathField: string,
    useLocationSearch: boolean = false,
    overwriteTaxonomies: boolean = false,
    resetLocation: boolean,
    searchState: SearchState,
  ): QueryParams {
    let potentialState: SearchState = this.getSearchResultsQueryParamsPotentialState(
      item,
      stateUrlPathField,
      useLocationSearch,
      overwriteTaxonomies,
      resetLocation,
      searchState,
    );
    return this.urlBuilder.CreateSearchResultsQueryParams(potentialState, false, true);
  }

  public getSearchResultsQueryParamsPotentialState(
    item: SearchWidgetDataItem | SearchWidgetContentListItem,
    stateUrlPathField: string,
    useLocationSearch: boolean = false,
    overwriteTaxonomies: boolean = false,
    resetLocation: boolean,
    searchState: SearchState,
  ): SearchState {
    let potentialState: SearchState = this.tools.clone(searchState);

    if (overwriteTaxonomies) {
      potentialState[SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE] =
        potentialState[SearchStateFieldsEnum.CARE_SERVICE_TYPE] =
        potentialState[SearchStateFieldsEnum.SYMPTOM] =
          '';
    }

    if (
      stateUrlPathField === SearchStateFieldsEnum.CAREPROVIDER_UNIT_TYPE ||
      stateUrlPathField === SearchStateFieldsEnum.CARE_SERVICE_TYPE ||
      stateUrlPathField === SearchStateFieldsEnum.SYMPTOM
    ) {
      potentialState.freeSearchTerm = '';
    }

    potentialState[stateUrlPathField] = !this.tools.isNil(item) ? item.urlPath : '';
    potentialState = this.modifySearchStateWithNewPotentialValues(potentialState, useLocationSearch, resetLocation);
    potentialState.attributes = {};
    potentialState.tab = this.searchHelper.getDefaultSearchTab(potentialState);
    return potentialState;
  }

  private modifySearchStateWithNewPotentialValues(
    searchState: SearchState,
    useLocationSearch: boolean,
    resetLocation: boolean,
  ): SearchState {
    searchState.page = 1;
    if (resetLocation === true) {
      searchState.locationSearch = false;
      searchState.lat = 0;
      searchState.lon = 0;
    }
    return searchState;
  }
}
